import { render } from "./PatientPharmacy.vue?vue&type=template&id=4b52fad0&ts=true"
import script from "./PatientPharmacy.ts?vue&type=script&lang=ts&external"
export * from "./PatientPharmacy.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__